import Vue from 'vue'

import Cookies from 'js-cookie'

import Element from 'element-ui'
Element.Dialog.props.closeOnClickModal.default = false;

import './assets/styles/element-variables.scss'

import '@/assets/styles/index.scss' // global css
import '@/assets/styles/ruoyi.scss' // ruoyi css
import App from './App'
import store from './store'
import router from './router'
import directive from './directive' // directive
import plugins from './plugins' // plugins
import { download } from '@/utils/request'

import './assets/icons' // icon
import './permission' // permission control
import { getDicts } from "@/api/system/dict/data"
import { getConfigKey } from "@/api/system/config"
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree,setLeafChildenNull } from "@/utils/ruoyi"
// 分页组件
import Pagination from "@/components/Pagination"
// 自定义表格工具组件
import RightToolbar from "@/components/RightToolbar"
// 富文本组件
import Editor from "@/components/Editor"
// 文件上传组件
import FileUpload from "@/components/FileUpload"
// 图片上传组件
import ImageUpload from "@/components/ImageUpload"
// 原若依ImageUpload-修改了名称
import Md5Upload from "@/components/Md5Upload"
// 原若依ImageUpload-修改了名称
import PictureUpload from "@/components/PictureUpload"
// 图片预览组件
import ImagePreview from "@/components/ImagePreview"
// 字典标签组件
import DictTag from '@/components/DictTag'
// 字典数据组件
import DictData from '@/components/DictData'

import ImageLine from "@/components/ImageLine"
import ImageList from "@/components/ImageList"
import ImagePicker from "@/components/ImagePicker"
import ImageChoose from "@/components/ImageChoose"
import VideoUpload from "@/components/VideoUpload"
import MediaPreview from "@/components/MediaPreview"
import MediaUpload from "@/components/MediaUpload"
import MediaPicker from "@/components/MediaPicker"
import MediaChoose from "@/components/MediaChoose"
import MediaList from "@/components/MediaList"
import Member from "@/components/Member"


// 全局方法挂载
Vue.prototype.getDicts = getDicts
Vue.prototype.getConfigKey = getConfigKey
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.download = download
Vue.prototype.handleTree = handleTree
Vue.prototype.setLeafChildenNull=setLeafChildenNull

// 全局组件挂载
Vue.component('DictTag', DictTag)
Vue.component('Pagination', Pagination)
Vue.component('RightToolbar', RightToolbar)
Vue.component('Editor', Editor)
Vue.component('FileUpload', FileUpload)
Vue.component('ImageUpload', ImageUpload)
Vue.component('Md5Upload', Md5Upload)
Vue.component('PictureUpload', PictureUpload)
Vue.component('ImagePreview', ImagePreview)
Vue.component('ImageLine', ImageLine)
Vue.component('ImageList', ImageList)
Vue.component('ImageChoose', ImageChoose)
Vue.component('ImagePicker', ImagePicker)
Vue.component('VideoUpload', VideoUpload)
Vue.component('MediaPreview', MediaPreview)
Vue.component('MediaUpload', MediaUpload)
Vue.component('MediaPicker', MediaPicker)
Vue.component('MediaChoose', MediaChoose)
Vue.component('MediaList', MediaList)
Vue.component('Member', Member)

Vue.use(directive)
Vue.use(plugins)
DictData.install()

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */

Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})

Vue.config.productionTip = false
Vue.config.devtools = true

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
